// src/components/BlogSection/BlogSection.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';

const POSTS = [
  {
    slug:     '/blog/what-is-a-kundali-reading',
    category: 'Vedic Astrology',
    icon:     '🌙',
    title:    'What is a Kundali Reading?',
    excerpt:  'A kundali is your Vedic birth chart — a precise map of the sky at your moment of birth. Discover what the 12 houses, 9 planets, and the Dasha system reveal about your personality, life path, and timing.',
    readTime: '8 min read',
  },
  {
    slug:     '/blog/vedic-astrology-vs-western-astrology',
    category: 'Vedic Astrology',
    icon:     '✨',
    title:    'Vedic Astrology vs Western Astrology',
    excerpt:  'Why does your sun sign change in Vedic astrology? What are nakshatras and dashas — and why do so many people find Jyotish more precise? A clear guide to the key differences between the two traditions.',
    readTime: '9 min read',
  },
  {
    slug:     '/blog/what-is-vaastu-shastra',
    category: 'Vaastu Shastra',
    icon:     '🏡',
    title:    'What is Vaastu Shastra?',
    excerpt:  'The ancient Vedic science of space and energy. Learn how the five elements, eight directions, and the placement of rooms affect the health, wealth, and harmony of everyone who lives or works in a space.',
    readTime: '8 min read',
  },
];

const BlogSection: React.FC = () => {
  return (
    <section id="blog" className="blog-section">
      <div className="container">
        <h2 className="section-title">From the <span className="gold-text">Blog</span></h2>
        <p className="section-subtitle">
          Deepen your understanding of Vedic astrology and ancient wisdom.
        </p>
        <div className="blog-grid">
          {POSTS.map(post => (
            <Link key={post.slug} to={post.slug} className="blog-card">
              <span className="blog-card-category">{post.category}</span>
              <div className="blog-card-icon">{post.icon}</div>
              <h3 className="blog-card-title">{post.title}</h3>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <div className="blog-card-footer">
                <span className="blog-card-meta">{post.readTime}</span>
                <span className="blog-card-link">Read article →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
